import styled from "styled-components"

const gradient = {
  linear: "linear-gradient(180deg, rgba(0, 0, 0, 0.028) 0%, rgba(0, 0, 0, 0.112) 100%)",
  radial: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.58) 100%);"
}

export const GradientOverlay = styled.div<{gradientType: keyof typeof gradient}>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 5px 5px 0 0;
  background: ${({gradientType = "radial"}) => gradient[gradientType]};
`
